import React from "react";
import { Box, Select, MenuItem, FormControl } from "@mui/material";
import toastAlert from "./toastAlert";

const TabsComponent = ({
  activeTab,
  setActiveTab,
  selectedSigner,
  template,
}) => {
  const handleChange = (event) => {
    if (event.target.value === "2" && selectedSigner.length === 0) {
      toastAlert("error", "Please Add Signer!");
    } else {
      setActiveTab(event.target.value);
    }
  };

  return (
    <>
      {template ? (
        <Box
          sx={{
            width: "100%",
            border: "1px solid rgba(0, 0, 0, 0.23)",
            // border: "1px solid lightgrey",
            borderRadius: "5px",
            // borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            mb: 2,
          }}
        >
          {/* <FormControl
       fullWidth
       size="small"
       sx={{
         "& .MuiOutlinedInput-root": {
           "& fieldset": {
             border: "1px solid rgba(0, 0, 0, 0.23)",
           },
           "&:hover fieldset": {
             borderColor: "rgba(0, 145, 255, 0.5)",
           },
           "&.Mui-focused fieldset": {
             borderColor: "rgb(35, 179, 232)",
           },
         },
       }}
     > */}

          <Box
            value="2"
            sx={{
              fontSize: "14px",
              py: 1,
              // MenuItem styling
              color:
                activeTab === "2" ? "rgb(35, 179, 232)" : "rgba(0, 0, 0, 0.7)",
              backgroundColor:
                activeTab === "2" ? "rgba(0, 145, 255, 0.16)" : "transparent",
              fontWeight: activeTab === "2" ? 600 : 400,
              "&:hover": {
                backgroundColor: "rgba(0, 145, 255, 0.08)",
                color: "rgb(35, 179, 232)",
              },
              "&.Mui-selected": {
                backgroundColor: "rgba(0, 145, 255, 0.16)",
                color: "rgb(35, 179, 232)",
                fontWeight: 600,
                "&:hover": {
                  backgroundColor: "rgba(0, 145, 255, 0.24)",
                },
              },
            }}
          >
            <span style={{ marginLeft: "10px" }}> For Others</span>
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            width: "100%",
            // border: "1px solid lightgrey",
            borderRadius: "5px",
            // borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            mb: 2,
          }}
        >
          <FormControl
            fullWidth
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "1px solid rgba(0, 0, 0, 0.23)",
                },
                "&:hover fieldset": {
                  borderColor: "rgba(0, 145, 255, 0.5)",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "rgb(35, 179, 232)",
                },
              },
            }}
          >
            <Select
              value={activeTab}
              onChange={handleChange}
              displayEmpty
              sx={{
                "& .MuiSelect-select": {
                  py: 1,
                  fontSize: "14px",
                  // Selected item in dropdown shows blue
                  color: "rgb(35, 179, 232)",
                  fontWeight: 600,
                },
              }}
            >
              <MenuItem
                value="1"
                sx={{
                  fontSize: "14px",
                  py: 1,
                  // MenuItem styling
                  color:
                    activeTab === "1"
                      ? "rgb(35, 179, 232)"
                      : "rgba(0, 0, 0, 0.7)",
                  backgroundColor:
                    activeTab === "1"
                      ? "rgba(0, 145, 255, 0.16)"
                      : "transparent",
                  fontWeight: activeTab === "1" ? 600 : 400,
                  "&:hover": {
                    backgroundColor: "rgba(0, 145, 255, 0.08)",
                    color: "rgb(35, 179, 232)",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(0, 145, 255, 0.16)",
                    color: "rgb(35, 179, 232)",
                    fontWeight: 600,
                    "&:hover": {
                      backgroundColor: "rgba(0, 145, 255, 0.24)",
                    },
                  },
                }}
              >
                For You
              </MenuItem>
              <MenuItem
                value="2"
                sx={{
                  fontSize: "14px",
                  py: 1,
                  // MenuItem styling
                  color:
                    activeTab === "2"
                      ? "rgb(35, 179, 232)"
                      : "rgba(0, 0, 0, 0.7)",
                  backgroundColor:
                    activeTab === "2"
                      ? "rgba(0, 145, 255, 0.16)"
                      : "transparent",
                  fontWeight: activeTab === "2" ? 600 : 400,
                  "&:hover": {
                    backgroundColor: "rgba(0, 145, 255, 0.08)",
                    color: "rgb(35, 179, 232)",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(0, 145, 255, 0.16)",
                    color: "rgb(35, 179, 232)",
                    fontWeight: 600,
                    "&:hover": {
                      backgroundColor: "rgba(0, 145, 255, 0.24)",
                    },
                  },
                }}
              >
                For Others
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
      )}
    </>
  );
};

export default TabsComponent;
